export const changeTopNavTitle = (
  context,
  desktopTitle = "",
  mobileTitle = ""
) => {
  const params = context.$route.params;
  context.$route.meta.sectionTitle = desktopTitle;
  context.$route.meta.mobileTitle = mobileTitle;
  context.$router.replace({ query: { temp: Date.now() }, params });
  context.$router.replace({ query: { temp: undefined }, params });
};
